import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import PapersGeneratorService from "services/PapersGeneratorService";
import PapersGeneratorSelectPopup from "./PapersGeneratorSelectPopup";
import PropTypes from "prop-types";

const PapersGeneratorRfxRequestPosition = (
    {
        demandId,
        paper,
        onClose,
        shareSystem
    }) => {

    const [requestPositions, setRequestPositions] = useState(null);


    useEffect(() => {
        PapersGeneratorService.getRfxRequestPosition(demandId).then(resp => setRequestPositions(resp));
    }, [demandId])

    return (
        <PapersGeneratorSelectPopup shareSystem={shareSystem} onClose={onClose} paperId={paper.paperId} title={Tr('choose_position')} list={requestPositions}/>
    )
}
PapersGeneratorRfxRequestPosition.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    paper: PropTypes.object.isRequired
}
export default PapersGeneratorRfxRequestPosition;